<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-dialog v-model="openAuditTrail" max-width="1200px">
      <app-audit-trail-timeline entity="protocol" v-if='openAuditTrail' :entity_id="$route.params.id" :fields='config.fields'/>
    </v-dialog>

    <v-flex>
      <app-upsert v-if="protocol.id"
        :config="config"
        :item="protocol"
        :title="protocol.name"
        :subtitle="`${protocol.status} - ${protocol.sponsor && protocol.sponsor.name || ''}`"
        class="mb-5"
        @saved="saved">


        <template slot='headerActions'>
          <app-audit-trail-btn @click="openAuditTrail = true" />
          <v-btn
            color="red"
            @click="$router.push('/protocol')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>        

        <template slot="actions">
          <v-badge
            color='green' overlap :value="nDrugs"
            :content="nDrugs">
            <v-btn
              id="drugs"
              color="primary"
              :to="`/protocol/${protocol.id}/drugs`">
              <v-icon
                small
                class="mr-1">mdi-pill</v-icon>  Drugs
            </v-btn>
          </v-badge>

          <v-badge
            v-if='user.role!=="EMN Estimates"'
            :content="nSites" color='green' overlap :value="nSites">
            <v-btn
              class="ml-2"
              color="primary"
              :to="`/protocol/${protocol.id}/sites`">
              <v-icon
                class="mr-1">mdi-home</v-icon> Sites
            </v-btn>
          </v-badge>

          <!-- <v-btn
            v-if="protocol.status === 'INIT'"
            color="success"
            class="ml-2"
            :disabled="!nDrugs || !nSites"
            @click="confirm"
            small>
            <v-icon
              small
              class="mr-1">mdi-check</v-icon> Confirm
          </v-btn> -->

          <v-btn
            v-if='$can("upsert", "request")'
            class="mx-1 font-weight-light"
            color="success"
            :to="`/protocol/${protocol.id}/request/new`"
            :disabled="!nDrugs || !nSites || protocol.status==='CANCELED'">
            <v-icon
              small
              class="mr-1">mdi-plus</v-icon> Add Request
          </v-btn>

          <v-btn
            v-if='$can("read", "request")'
            class="mx-1 font-weight-light"
            color="success"
            :to="`/protocol/${protocol.id}/request`"
            :disabled="!nDrugs || !nSites || protocol.status==='CANCELED'">
            <v-icon
              small
              class="mr-1">mdi-list</v-icon> Request list
          </v-btn>          

          <v-btn
            class="mx-1"
            @click='toggleActive'
            :disabled="!nDrugs || !nSites || protocol.status==='CANCELED'"
            :color="protocol.status==='CLOSED' || protocol.status === 'INIT' ?'green':'danger'">
            <v-icon
              class="mr-1">mdi-{{protocol.status==='CLOSED' || protocol.status === 'INIT' ?'check':'close'}}</v-icon> {{protocol.status === 'CLOSED' || protocol.status === 'INIT' ?'Enable':'Disable'}}
          </v-btn>

          <v-btn
            class="mx-1"
            @click='cancel'
            :disabled="nDrugs == null || protocol.status==='CANCELED'"
            color="red">
            <v-icon
              class="mr-1">mdi-close</v-icon>Cancel
          </v-btn>


        </template>
      </app-upsert>
    </v-flex>

  </v-container>
</template>

<script>
import { getDetail, upsert, getCount } from '@/api/base_entity'
import { mapState } from 'vuex'

import config from './config_index.json'

export default {
  data () {
    return {
      config,
      itemId: null,
      openDrugs: false,
      openSite: false,
      openStorage: false,
      openDisposal: false,
      hiddenFields: {},
      protocol: { sponsor: {} },
      nDrugs: null,
      nSites: 0,
      openAuditTrail: false
    }
  },
  computed: mapState(['user']),
  async created () {
    this.protocol = await getDetail('protocol', { id: this.$route.params.id })
    this.hiddenFields = { protocol_id: this.protocol.id }

    this.nDrugs = await getCount('drug', { protocol_id: this.protocol.id })

    this.nSites = await getCount('protocol_has_site', { protocol_id: this.protocol.id })
  },
  methods: {
    saved (item) {
      this.itemId = Number(item.assetId)
      this.hiddenFields = { protocol_id: this.itemId }
    },
    confirm () {
      const protocol = Object.assign({}, this.protocol)
      protocol.status = 'CONFIRMED'
      upsert('protocol', protocol)
      this.protocol.status='CONFIRMED'
      // this.$router.reload()
    },
    loaded (protocol) {
      this.protocol = protocol
    },
    async toggleActive () {
      let ret = true
      const protocol = Object.assign({}, this.protocol)
      if (protocol.status === 'ACTIVE') {
        ret = await this.$root.$confirm.open('Disable protocol', `Are you sure to disable the protocol <u>${protocol.name}</u>?`)
      } else {
        ret = await this.$root.$confirm.open('Enable protocol', `Are you sure to enable the protocol <u>${protocol.name}</u>?`)
      }
      if (!ret) return
      protocol.status = protocol.status === 'ACTIVE' ? 'CLOSED' : 'ACTIVE'
      ret = await upsert('protocol', protocol)
      if (ret && ret.data.status) {
        this.protocol.status = ret.data.status
      }
    },
    async cancel () {
      let ret = true
      const protocol = Object.assign({}, this.protocol)
      ret = await this.$root.$confirm.open('Cancel protocol', `Are you sure to cancel the protocol <u>${protocol.name}</u>?`)
      if (!ret) return
      protocol.status = 'CANCELED'
      ret = await upsert('protocol', protocol)
      if (ret && ret.data.status) {
        this.protocol.status = ret.data.status
      }
    }
  }
}
</script>